import ApiService from '@/services/api.service'

// Get url params
let urlString = window.location.href
let paramString = urlString.split('?')[1]
let queryString = new URLSearchParams(paramString)
let endObj = {
    lang: null,
}

for (let pair of queryString.entries()) {
    if (pair[0] == 'lang') {
        endObj.lang = pair[1]
    }
}

let currentLang = localStorage.getItem('langage') || 'fr'
if (endObj.lang) {
    currentLang = endObj.lang
}
if (currentLang.toLowerCase() == 'en-gb') {
    currentLang = 'en'
}

let langs = null

async function init() {
    let response = await ApiService.post('traduction.list', {
        key: 'selfcare',
        lang: currentLang,
    }, 'api2')
    langs = response.data.posts.post
}

async function addText(keyword) {
    await ApiService.post('traduction.add-text', {
        key: 'selfcare',
        content: keyword,
        lang: currentLang,
    }, 'api2')
}

function getText(keyword)
{
    if (langs) {
        if (!langs[keyword]) {
            langs[keyword] = keyword
            addText(keyword)
        }
        return langs[keyword]
    }
    return null
}

export default {
    init,
    getText
}



// WEBPACK FOOTER //
// ./src/tools/LangTextTool.js